export default __webpack_public_path__ + "static/media/icon-survey-orange.d5cd3cba.png";